'use client';

import React, { useCallback, useMemo } from 'react';
import type { CartCounterButtonWidgetProps } from './cart-counter-button.types';
import styles from './cart-counter-button.module.css';
import { cn, Text, Button } from '../../../../utils';
import { useTranslation } from 'next-i18next';
import { CartCounterButtonEnum } from '../../../../enums';
/**
 * CartCounterButtonWidget - Counter widget for adjusting product quantity
 * Converted from React Native to Next.js using UI Core components
 */
export const CartCounterButtonWidget: React.FC<CartCounterButtonWidgetProps> = ({
    handleIncrease,
    handleDecrease,
    emitValueChange,
    value,
    className,
    variant = CartCounterButtonEnum.FULL,
}) => {
    const { t } = useTranslation('flash-sale');
    const handleIncreaseClick = useCallback(() => {
        handleIncrease?.(1);
    }, [handleIncrease]);

    const handleDecreaseClick = useCallback(() => {
        handleDecrease?.(1);
    }, [handleDecrease]);

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = parseInt(e.target.value, 10);
            if (!isNaN(newValue) && newValue >= 1) {
                emitValueChange?.(newValue);
            }
        },
        [emitValueChange]
    );
    const containerClassByVariant = useMemo(
        () => ({
            full: styles.container,
            counter: cn(styles.container, styles.containerCounter),
        }),
        []
    );

    return (
        <div className={cn(containerClassByVariant[variant], className)}>
            <Text showIf={variant === CartCounterButtonEnum.FULL} size="small" className={styles.descriptionText}>
                {t('flash_sale_gift_hint')}
            </Text>

            <div className={styles.counterRow}>
                <Text size="medium" weight="medium" className={styles.counterText}>
                    {t('flash_sale_quantity_label')}
                </Text>

                <div className={styles.counterButtonGroup}>
                    <Button
                        variant="outlined"
                        size="small"
                        className={styles.counterButton}
                        onPress={handleDecreaseClick}
                        disabled={value <= 1}
                        aria-label={t('flash_sale_decrease_quantity')}
                    >
                        −
                    </Button>

                    <input
                        type="number"
                        className={styles.counterInput}
                        value={value}
                        onChange={handleInputChange}
                        min={1}
                        aria-label={t('Số lượng')}
                    />

                    <Button
                        variant="outlined"
                        size="small"
                        className={styles.counterButton}
                        onPress={handleIncreaseClick}
                        aria-label={t('flash_sale_increase_quantity')}
                    >
                        +
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CartCounterButtonWidget;
